import { integrations } from 'config';

const getBastionStage = () => {
  switch (integrations.stage) {
    case 'production':
      return import('./envs/prod');
    case 'demo':
      return import('./envs/demo');
    case 'staging':
      return import('./envs/staging');
    case 'kintodev':
      return import('./envs/kintodev');
    case 'alpha1':
      return import('./envs/alpha1');
    case 'alpha2':
      return import('./envs/alpha2');
    case 'local':
      return import('./envs/local');
    case 'beta':
      return import('./envs/beta');
    default:
      return import('./envs/beta');
  }
};

export default getBastionStage().default;
